function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M47.6 7.4s-.4-3.4-2-4.8c-1.8-2-3.8-2-4.8-2C34 .2 24 .2 24 .2S14 .2 7.2.6c-1 .2-3 .2-4.8 2C1 4 .4 7.4.4 7.4S0 11.2 0 15.2v3.6c0 3.8.4 7.8.4 7.8s.4 3.4 2 4.8c1.8 2 4.2 1.8 5.2 2 3.8.4 16.4.4 16.4.4s10 0 16.8-.6c1-.2 3-.2 4.8-2 1.4-1.4 2-4.8 2-4.8s.4-3.8.4-7.8V15c0-3.8-.4-7.6-.4-7.6zM19 23.2V9.8l13 6.8-13 6.6z"
});

function SvgYoutubeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 34"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0OCAzNCI+PHBhdGggZmlsbD0iI0ZGMDAwMCIgZD0iTTQ3LjYgNy40cy0uNC0zLjQtMi00LjhjLTEuOC0yLTMuOC0yLTQuOC0yQzM0IC4yIDI0IC4yIDI0IC4yUzE0IC4yIDcuMi42Yy0xIC4yLTMgLjItNC44IDJDMSA0IC40IDcuNC40IDcuNFMwIDExLjIgMCAxNS4ydjMuNmMwIDMuOC40IDcuOC40IDcuOHMuNCAzLjQgMiA0LjhjMS44IDIgNC4yIDEuOCA1LjIgMiAzLjguNCAxNi40LjQgMTYuNC40czEwIDAgMTYuOC0uNmMxLS4yIDMtLjIgNC44LTIgMS40LTEuNCAyLTQuOCAyLTQuOHMuNC0zLjguNC03LjhWMTVjMC0zLjgtLjQtNy42LS40LTcuNlpNMTkgMjMuMlY5LjhsMTMgNi44LTEzIDYuNloiLz48L3N2Zz4=";
export { SvgYoutubeLogo as ReactComponent };